import React from 'react'
import { Grid, Button, Box, Typography, } from "@mui/material";
import SaturacionIcon from "./img/saturacion.png";

const Saturacion = (props) => {
    const getColor = () => {
        return props.showSaturacion && ( props.medicion !== "N/D" ) ? 'rgb(5, 118, 80,0.1)' : 'rgb(5, 118, 80,0)';
    };
    return (
        <Button style={{ backgroundColor: getColor() }} onClick={props.toggleSaturacion} sx={{ border: "0.15vh solid #057650", height: props.fullHeight, width: props.fullwidth }} disabled={props.medicion === 'N/D'} >
            <Grid container spacing={0} alignItems="top" justifyContent="center" >

                {/* Card de oxígeno */}
                <Grid item xs={6}  >
                    <Box display='flex' direction="column" alignItems="center" justifyContent="center" width={props.width} height={props.height} >
                        <img src={SaturacionIcon} alt="Icono" style={{ marginLeft:props.marginLeft1, width: props.widthIMG, height: props.heightIMG, position: 'center' }} />
                        {!props.sinText && (
                            <Typography style={{ fontSize: props.fontSize, cursor: 'default !important', userSelect: 'none' }} color="white">
                                {props.saturacion}
                            </Typography>
                        )}
                    </Box>
                </Grid>

                {/* Card de número */}
                <Grid item xs={6} >
                    <Box style={{ width: props.width1, height: props.height1, backgroundColor: "transparent", marginLeft: props.marginLeft1, textTransform: 'none' }}>
                        <Grid container direction="column" alignItems="center" justifyContent="center" style={{ height: '95%', cursor: 'default !important', userSelect: 'none' }}>
                            <Typography variant="h1" style={{ fontSize: props.fontSizeH1, fontWeight: 1000, color: 'white' }}>
                                {props.medicion}
                            </Typography>
                            <Typography variant="h1" style={{ fontSize: props.fontSizeTypo1, fontWeight: 300, color: 'white' }}>
                                %
                            </Typography>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Button>
    );
};

export default Saturacion;



/* 

const Saturacion = (props) => {
    return (
        <Grid container spacing={0} alignItems="top" justifyContent="center" >
            <Grid item xs={6}>
                <Button
                    style={{
                        minWidth: "1vw",
                        width: props.width,
                        height: props.height,
                        backgroundColor: 'transparent'// props.showSaturacion ? "rgb(65, 105, 225)" : "rgb(65, 105, 225,0.4)"
                    }}
                    onClick={props.toggleSaturacion}
                >
                    <Grid container direction="column" alignItems="center" justifyContent="center">
                        <img src={SaturacionIcon} alt="Icono" style={{ width: props.widthIMG, height: props.heightIMG }} />
                        {!props.sinText && (
                            <Typography style={{ fontSize: props.fontSize, cursor: 'default !important', userSelect: 'none' }} color="white">
                                {props.saturacion}
                            </Typography>
                        )}
                    </Grid>
                </Button>
            </Grid>

            <Grid item xs={6} >
                <Card style={{ width: props.width1, height: props.height1, backgroundColor: "black", border: "0.1vh solid white", marginLeft: `${props.marginLeft1}` }}>
                    <Grid container direction="column" alignItems="center" justifyContent="center" style={{ height: '95%' , cursor: 'default !important', userSelect: 'none'}}>
                        <Typography variant="h1" style={{ fontSize: props.fontSizeH1, fontWeight: 1000 }}>
                            {props.medicion}
                        </Typography>
                        <Typography variant="h1" style={{ fontSize: props.fontSizeTypo1, fontWeight: 1000 }}>
                            %
                        </Typography>
                    </Grid>
                </Card>
            </Grid>
        </Grid>
    );
};

export default Saturacion;

 */